import { api } from "aldoo-ra/API"

const adsAPI = api("aldoo-ads")

/**
 * Resolve an ad's serve payload ({ html, click_url }) through the local
 * install's api. `account` (AdAccount id or api_url) targets a connected
 * remote account; omitted = local ad. Works in SSR and the browser.
 */
export const ServeAd = async (id, account) => {
  return await adsAPI({ serve_proxy: { id, ...(account ? { account } : {}) } })
}

/**
 * Impression beacon — goes DIRECT to the origin account's api (derived from
 * click_url) so counters live where the ads live. Endpoint is CORS-open;
 * keepalive lets it survive quick navigations. Fire-and-forget.
 */
export const TrackImpression = (serveData) => {
  if (typeof window === "undefined") return
  if (!serveData?.click_url || !serveData?.ad) return
  try {
    // click_url = <origin-api>/v1/aldoo-ads/click/<adId> → strip to the endpoint
    const endpoint = serveData.click_url.replace(/\/click\/.*$/, "")
    fetch(endpoint, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      keepalive: true,
      body: JSON.stringify({
        impression: { id: serveData.ad, origin: window.location.host },
      }),
    }).catch(() => {})
  } catch {
    /* tracking is best-effort */
  }
}

/** Click destination with the serving site's host as utm_source origin. */
export const clickHref = (serveData) => {
  if (!serveData?.click_url) return null
  const origin = typeof window === "undefined" ? "" : window.location.host
  return `${serveData.click_url}?origin=${encodeURIComponent(origin)}`
}

// ── placements: the site's own spots, served whole and rendered by the site ──

/** A placement's live ads: { placement, utm_medium, items: [...] } or { result: false }. */
export const ServePlacement = async (key, language) => adsAPI({ placement: { key, language } })

/** One impression of a placement's ad (deduped per visitor on the server). */
export const TrackAdImpression = (id) => {
  if (typeof window === "undefined" || !id) return
  adsAPI({ impression: { id, origin: window.location.host } }).catch(() => {})
}

/** A click on a placement's ad; the page navigates by itself. */
export const TrackAdClick = (id) => {
  if (typeof window === "undefined" || !id) return
  adsAPI({ click: { id, origin: window.location.host } }).catch(() => {})
}

/** Admin: every placement with every ad of it (stopped ones too). */
export const ListPlacements = async (params = {}) => adsAPI({ placements: params })

/** Admin: the site's products by text, for an ad's product. */
export const SearchAdProducts = async (text, language) => adsAPI({ product_search: { text, language } })
